import React, { useEffect, useState } from 'react'
import A4Page from '../A4Page'
import TopDetail from '../TopDetail'
import Page1 from './Page1'
import useOrderStore from 'store/client/orderStore'
import { ReactComponent as ZaraFscSimsek} from '../../../../../assets/globalsymbol/fscsimsekbestgray.svg'
import { ReactComponent as ZaraFscHarman } from '../../../../../assets/globalsymbol/harmanbestgray.svg'
import { ReactComponent as ZaraFscRpack } from '../../../../../assets/globalsymbol/rpackbestgray.svg'


const loadSVG = async (code) => {
  try {
    console.log(`[loadSVG] Gelen kod: ${code}`);
    const module = await import(`../../../../../assets/addional/${code}.svg`);
    console.log(`[loadSVG] İçe aktarılan module:`, module);
    return module.ReactComponent || module.default || null;
  } catch (error) {
    console.error(`[loadSVG] SVG yüklenemedi. Kod: ${code}, Hata:`, error);
    return null;
  }
};

const CardComponent = ({ referenceCode, data, selectedFscType,referance }) => {
  const [SvgComponent, setSvgComponent] = useState(null);
  const [FscComponent, setFscComponent] = useState(null);
  const [bottom, setBottom] = useState(18.6);
  const [right, setRight] = useState(19);
  const [Reverse, setReverse] = useState(false);


  console.log("DataBu",data.company.id)
  useEffect(() => {
    console.log("gerçek referans",referance)

    if(referance?.shape2==="littleupper")
    {
      setBottom(57.6)
      setRight(41)
    }
    if(referance?.shape2==="littleupper2")
    {

      setBottom(82.1)
      setRight(52.6)
    }
    if(referance?.shape2==="littleupper3")
    {

      setBottom(102.2)
      setRight(42.6)
    }
    if(referance?.shape2==="doublelittle")
    {

      setBottom(18.6)
      setRight(107.5)
    }
    if(referance?.shape2==="reverseone")
    {

      setBottom(73.6)
      setRight(19.5)
      setReverse(true)
    }
    switch (data.company.id) {
      case "676976a49044968a2edbea39":
        setFscComponent(() => ZaraFscRpack);
        break;
      case "6562742a5b252fdddcc588e7":
        setFscComponent(() => ZaraFscHarman);
        break;
      default:
        setFscComponent(() => ZaraFscSimsek);
    }
  
    if (referenceCode) {
      loadSVG(referenceCode)
        .then((component) => {
          setSvgComponent(() => component);
        })
        .catch((error) => {
          console.error("[CardComponent] SVG yüklenirken hata:", error);
        });
    }
  }, [referenceCode]);

  if (!SvgComponent) {
    return <span>Loading...</span>;
  }

  return (
    <div style={{ position: "relative" }}>
      {typeof SvgComponent === "function" ? (
        <SvgComponent />
      ) : (
        <img src={SvgComponent} alt="SVG Image" style={{ width: "auto", height: "auto" }} />
      )}
      {referance.shape === "nosymbol" ? (
        <></>
      ) : (
        <div
  style={{
    position: "absolute",
    bottom: Reverse ? "auto" : bottom,
    right: Reverse ? "auto" : right,
    top: Reverse ? bottom : "auto",
    left: Reverse ? right : "auto",
    transform: Reverse ? "rotate(-180deg)" : "none",
  }}
>
  <FscComponent width="5.5mm" height="8.3mm" fill="red" />
</div>


        )}


    </div>
  );
};

const AddionalMain = ({ data, selectColor, tab }, ref) => {
  const [CardBackBack, setCardBackBack] = useState(null);
  const { referance } = useOrderStore();

  useEffect(() => {
    if (referance?.code) {
      loadSVG(referance.code)
        .then((component) => {
          setCardBackBack(() => component);
        })
        .catch((error) => {
          console.error("[useEffect - referance] SVG yüklenirken hata:", error);
        });
    }
  }, [referance]);

  const filteredAndGroupedSizes = data.brandLabel[selectColor].sizes
    .filter((item) => item.amount > 0)
    .reduce((acc, item, index) => {
      const groupIndex = Math.floor(index / referance?.linecount);
      if (!acc[groupIndex]) {
        acc[groupIndex] = { items: [], startIndex: index - (index % referance?.linecount) };
      }
      acc[groupIndex].items.push(item);
      return acc;
    }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} ref={ref}>
      {referance?.line1 ? (
        filteredAndGroupedSizes.map((groupObj, groupIndex) => (
          <A4Page key={groupIndex} type={referance?.line3}>
            <div className="space-y-5" style={{ position: 'relative' }}>
              <TopDetail values={data} selectColor={selectColor} tab={tab} />
              {groupObj.items.map((sizeData, index) => (
                <div key={index} style={{ position: "absolute", top: "10px", left: "10px" }}>
                  <Page1
                    key={groupObj.startIndex + index}
                    selectColor={selectColor}
                    barcodeValue={`0${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.priceLabel[selectColor]?.colorCode}${sizeData.sCode ? sizeData.sCode : ''}`}
                    data={data}
                    sizeData={sizeData}
                    inx={groupObj.startIndex + index}
                    CardBackBack={CardBackBack}
                  />
                </div>
              ))}
            </div>
          </A4Page>
        ))
      ) : (
        <A4Page key={1} type="dikey">
          <div className="space-y-5" style={{ position: 'relative' }}>
            <TopDetail values={data} selectColor={selectColor} tab={tab} />
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", paddingTop: 40 }}>
              <CardComponent referenceCode={referance?.code} data={data} selectedFscType={data.company?.fsctype} referance={referance} />
            </div>
          </div>
        </A4Page>
      )}
    </div>
  );
};

export default React.forwardRef(AddionalMain);
